import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	TitlePlusModalComponent,
	TitlePlusModalData,
} from '../title-plus-modal/title-plus-modal.component';
import { TitlePlusStatus } from '@models/title-insurance';
import { TestHooks } from './title-plus-declined.hooks';

@Component({
	selector: 'app-title-plus-declined',
	templateUrl: './title-plus-declined.component.html',
	styleUrls: ['./title-plus-declined.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusDeclinedComponent {
	testHooks = TestHooks;
	@Input() status: TitlePlusStatus;

	public ICON = ICON;
	public TitlePlusStatus = TitlePlusStatus;

	constructor(private dialog: MatDialog) {}

	openPortal() {
		const data: TitlePlusModalData = {
			submitNewOrder: true,
		};

		this.dialog.open(TitlePlusModalComponent, { data });
	}
}
